export default __webpack_public_path__ + "static/media/android-chrome-512x512.c6ef9aa9.png";